import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServiceProvider from "../../models/serviceProvider";
import serviceProviderService from "../../services/serviceProviderService";
import Address from "../../models/address";
import ModalWindow from "../../components/common/ModalWindow";
import ValidationManager from "../../components/common/validationManager";
import Moment from "react-moment";
import dateTimeHelper from "../../util/datetimeHelper";
import { ItemsListEditor } from "../../components/common/ItemsListEditor";
import ServiceTrade from "../../models/serviceTrade";
import ServiceTradeEdit from "../../components/common/ServiceTradeEdit";
import ServiceArea from "../../models/serviceArea";
import ServiceAreaEdit from "../../components/common/ServiceAreaEdit";

const ServiceProviderView: React.FC = () => {
  const { id: idParam } = useParams();
  const [isBusy, setIsBusy] = useState<boolean>(false);
  // const [errorMessage, setErrorMessage] = useState<string>(""); //left here maybe s0me errors will need to be shown at some point

  const [serviceProvider, setServiceProvider] = useState<ServiceProvider>(
    new ServiceProvider()
  );

  const [serviceProviderClone, setServiceProviderClone] =
    useState<ServiceProvider>(new ServiceProvider());
  const [validationManager] = useState<ValidationManager>(
    new ValidationManager()
  );

  const [showEditServiceTradeWindow, setShowEditServiceTradeWindow] =
    useState<boolean>(false);

  const [showEditServiceAreaWindow, setShowEditServiceAreaWindow] =
    useState<boolean>(false);

  useEffect(() => {
    const initEdit = async (idServiceProvider: number) => {
      try {
        const { data: serviceProvider } =
          await serviceProviderService.getServiceProviderById(
            idServiceProvider
          );

        if (serviceProvider) {
          setServiceProvider(serviceProvider);
          //setServiceProviderClone(serviceProvider);
        }
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    const idServiceProvider = Number(idParam);
    initEdit(idServiceProvider);
  }, [idParam, validationManager]);

  const onActions = () => {};

  const onAddServiceTrade = () => {
    setShowEditServiceTradeWindow(true);
    setIsBusy(true);
    setServiceProviderClone(serviceProvider);
  };

  const onAddServiceTradeOk = async () => {
    setShowEditServiceTradeWindow(false);

    for (const t of serviceProviderClone.serviceTrades) {
      t.idServiceProvider = serviceProviderClone.idServiceProvider;
    }

    const { data: updatedServiceProvider } =
      await serviceProviderService.updateListOfServiceTrades(
        serviceProviderClone.idServiceProvider,
        serviceProviderClone.serviceTrades
      );
    setServiceProvider(updatedServiceProvider);
    setIsBusy(false);
  };

  const onAddServiceTradeCancel = () => {
    setShowEditServiceTradeWindow(false);
    setIsBusy(false);
  };

  const onAddServiceArea = () => {
    setShowEditServiceAreaWindow(true);
    setIsBusy(true);
    setServiceProviderClone(serviceProvider);
  };

  const onAddServiceAreaOk = async () => {
    setShowEditServiceAreaWindow(false);
    setIsBusy(false);

    for (const t of serviceProviderClone.serviceAreas) {
      t.idServiceProvider = serviceProviderClone.idServiceProvider;
    }

    const { data: updatedServiceProvider } =
      await serviceProviderService.updateListOfServiceAreas(
        serviceProviderClone.idServiceProvider,
        serviceProviderClone.serviceAreas
      );
    setServiceProvider(updatedServiceProvider);
  };

  const onAddServiceAreaCancel = () => {
    setShowEditServiceAreaWindow(false);
    setIsBusy(false);
  };

  const onServiceTradesChanged = async (serviceTrades: ServiceTrade[]) => {
    const newServiceProvider = {
      ...serviceProvider,
      serviceTrades: serviceTrades,
    };
    setServiceProviderClone(newServiceProvider);
  };

  const onServiceAreasChanged = async (serviceAreas: ServiceArea[]) => {
    const newServiceProvider = {
      ...serviceProvider,
      serviceAreas: serviceAreas,
    };
    setServiceProviderClone(newServiceProvider);
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>View Service Provider</h1>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg">
            <div className="card p-4">
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between">
                  <div>
                    <h3>{serviceProvider.serviceProviderName}</h3>
                  </div>

                  <div>
                    <button
                      type="reset"
                      className="btn btn-danger"
                      disabled={isBusy}
                      onClick={() => onActions()}
                    >
                      Actions
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  className="card col-md-6"
                  style={{
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="card-header"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    Service Provider Address
                  </div>

                  <div className="card-body">
                    <p>{Address.getAddressLines(serviceProvider.address)}</p>
                    <p>
                      {Address.getCityStateZipCode(serviceProvider.address)}
                    </p>
                    <p>{serviceProvider.address.country}</p>
                    <p>Email Address: {serviceProvider.email}</p>
                    <p>Phone: {serviceProvider.phone}</p>
                  </div>
                </div>

                <div
                  className="card col-md-6"
                  style={{
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="card-header"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    Contact Person/Technician Information
                  </div>

                  <div className="card-body">
                    {serviceProvider.contactPersonName && (
                      <p>{serviceProvider.contactPersonName}</p>
                    )}
                    {serviceProvider.contactPersonEmail && (
                      <p>Email Address: {serviceProvider.contactPersonEmail}</p>
                    )}
                    {serviceProvider.contactPersonPhone && (
                      <p>Phone: {serviceProvider.contactPersonPhone}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="dispatchInstructions" className="form-label">
                  Service Instructions
                </label>
                <textarea
                  className="form-control"
                  id="dispatchInstructions"
                  value={
                    serviceProvider.dispatchInstructions == null
                      ? ""
                      : serviceProvider.dispatchInstructions
                  }
                  disabled={true}
                  style={{ height: "100px" }}
                />
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <p>Payment Terms</p>
                </div>
                <div className="col-md-3">
                  <p>{serviceProvider.paymentTerm}</p>
                </div>

                <div className="col-md-3">
                  <p>Insurance Expiration Date</p>
                </div>
                <div className="col-md-3">
                  <span>
                    <Moment format={dateTimeHelper.dateFormat}>
                      {serviceProvider.insuranceExpirationDate}
                    </Moment>
                  </span>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <p>Dispatch Option</p>
                </div>
                <div className="col-md-3">
                  <p>
                    {ServiceProvider.dispatchMethodToString(serviceProvider)}
                  </p>
                </div>

                <div className="col-md-3">
                  <p>Has Access to Vendor Portal</p>
                </div>
                <div className="col-md-3">
                  <span>Yes/No</span>
                </div>
              </div>

              <div className="row">
                <div
                  className="card col-md-5"
                  style={{
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="card-header d-flex justify-content-center"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    <button
                      type="reset"
                      className="btn btn-primary"
                      disabled={isBusy}
                      onClick={() => onAddServiceArea()}
                    >
                      Edit Service Area
                    </button>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover table-responsive">
                        <thead>
                          <tr>
                            <th scope="col">City Name</th>
                            <th scope="col">Zip Code</th>
                            <th scope="col">Radius</th>
                            <th style={{ width: "50px" }} />
                          </tr>
                        </thead>
                        {serviceProvider.serviceAreas !== undefined &&
                          serviceProvider.serviceAreas.length > 0 && (
                            // <div></div>
                            <tbody>
                              {serviceProvider.serviceAreas.map(
                                (serviceArea: ServiceArea) => (
                                  <tr
                                    key={
                                      !serviceArea
                                        ? ""
                                        : serviceArea?.idServiceArea?.toString()
                                    }
                                  >
                                    <td>{serviceArea.cityName}</td>
                                    <td>{serviceArea.zipCode}</td>
                                    <td>{serviceArea.radius}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          )}
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  className="card col-md-7"
                  style={{
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="card-header d-flex justify-content-center"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    <button
                      type="reset"
                      className="btn btn-primary"
                      disabled={isBusy}
                      onClick={() => onAddServiceTrade()}
                    >
                      Edit Service Trades
                    </button>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover table-responsive">
                        <thead>
                          <tr>
                            <th scope="col">Trade Name</th>
                            <th scope="col">Standard Labor</th>
                            <th scope="col">Overtime Labor</th>
                            <th scope="col">Holiday Labor</th>
                          </tr>
                        </thead>
                        {serviceProvider.serviceTrades !== undefined &&
                          serviceProvider.serviceTrades.length > 0 && (
                            // <div></div>
                            <tbody>
                              {serviceProvider.serviceTrades.map(
                                (serviceTrade: ServiceTrade) => (
                                  <tr
                                    key={
                                      !serviceTrade
                                        ? ""
                                        : serviceTrade?.idServiceTrade?.toString()
                                    }
                                  >
                                    <td>{serviceTrade.trade?.tradeName}</td>
                                    <td>{serviceTrade.regularTimeRate}</td>
                                    <td>{serviceTrade.overtimeRate}</td>
                                    <td>{serviceTrade.holidayRate}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row text-center">
                {errorMessage !== "" && (
                  <div className="error-message">{errorMessage}</div>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {showEditServiceTradeWindow && (
        <ModalWindow
          isExtraLarge={true}
          title="Edit Service Trades"
          onOk={onAddServiceTradeOk}
          onCancel={onAddServiceTradeCancel}
          isOkEnabled={true}
        >
          <div>
            <ItemsListEditor
              title=""
              fields={serviceProviderClone.serviceTrades}
              fieldsChanged={onServiceTradesChanged}
              Component={ServiceTradeEdit}
              isNew={true}
              validationManager={validationManager}
            />
          </div>
        </ModalWindow>
      )}

      {showEditServiceAreaWindow && (
        <ModalWindow
          isExtraLarge={true}
          title="Edit Service Areas"
          onOk={onAddServiceAreaOk}
          onCancel={onAddServiceAreaCancel}
          isOkEnabled={true}
        >
          <div>
            <ItemsListEditor
              title=""
              fields={serviceProviderClone.serviceAreas}
              fieldsChanged={onServiceAreasChanged}
              Component={ServiceAreaEdit}
              isNew={true}
              validationManager={validationManager}
            />
          </div>
        </ModalWindow>
      )}
    </main>
  );
};

export default ServiceProviderView;
